import { useRef, useEffect } from 'react';
import RowNumber from './RowNumber';

function useRowNumber(rows, notUse, serverFiltering, serverLimit) {
  let rowCount = 0;
  let filteredCount = 0;
  if (!notUse && rows) {
    if (Array.isArray(rows)) {
      rowCount = rows.length;
      filteredCount = rowCount;
    } else {
      rowCount = rows.totalCount || 0;
      filteredCount = rows.filteredCount || 0;
    }
  }
  const ref = useRef(notUse ? undefined : new RowNumber(filteredCount, rowCount, serverLimit));
  useEffect(() => {
    if (!notUse) {
      if (serverFiltering) {
        ref.current.setRowNumbers(filteredCount, rowCount);
      } else {
        ref.current.setTotalRowCount(rowCount);
      }
    }
  }, [filteredCount, rowCount]);
  return ref.current;
}

export default useRowNumber;
